import type { FC } from "react"
import { useNavigate } from "react-router-dom"

import * as Tabs from "@radix-ui/react-tabs"

import styles from "./CompanyTabBar.module.scss"

export type TabDefinition = {
	id: string // URL クエリパラメータ値
	label: string // タブ表示名
	disabled?: boolean // プレースホルダータブ
}

export const COMPANY_DETAIL_TABS: TabDefinition[] = [
	{ id: "general", label: "一般情報" },
	{ id: "sending-rule-master", label: "配信ルールマスタ" },
	{ id: "sending-rule-mapping", label: "配信ルール・店舗 紐付け" },
	{ id: "sending-start-settings", label: "送信開始設定" },
	{ id: "datasource-config", label: "媒体設定" },
	{ id: "usage-start-date", label: "利用開始日" },
	{ id: "feature-flag", label: "Feature Flag" },
	{ id: "fee-rate", label: "手数料" },
]

export const DEFAULT_TAB = "general"

export const VALID_TAB_IDS = new Set(COMPANY_DETAIL_TABS.map((t) => t.id))

type CompanyTabBarProps = {
	activeTab: string
	companyId: string
	isEditPage?: boolean
}

const CompanyTabBar: FC<CompanyTabBarProps> = ({
	activeTab,
	companyId,
	isEditPage,
}) => {
	const navigate = useNavigate()

	const handleTabClick = (tabId: string) => {
		if (isEditPage) {
			// 編集ページではタブクリックで詳細画面の該当タブに遷移
			navigate(`/souhl_admin/companies/${companyId}?tab=${tabId}`)
		}
		// 詳細ページでは Tabs.Root の onValueChange で処理
	}

	return (
		<Tabs.List className={styles.tabBar}>
			{COMPANY_DETAIL_TABS.map((tab) => (
				<Tabs.Trigger
					key={tab.id}
					value={tab.id}
					className={`${styles.tab} ${tab.disabled ? styles.disabled : ""} ${activeTab === tab.id ? styles.active : ""}`}
					disabled={tab.disabled}
					onClick={isEditPage ? () => handleTabClick(tab.id) : undefined}
				>
					{tab.label}
				</Tabs.Trigger>
			))}
		</Tabs.List>
	)
}

export default CompanyTabBar
